import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../config";

export const createOrder = createAsyncThunk(
  "order/createOrder",
  async (payload, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/orders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${payload.token}`,
        },
        body: JSON.stringify(payload.orderData),
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
export const getAllOrders = createAsyncThunk(
  "order/getAllOrders",
  async (token, thunkAPI) => {
    try {
      const response = await fetch(`${API_BASE_URL}/orders/customer`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response?.json();
        return thunkAPI.rejectWithValue(errorData?.message); // Use the error message from the server response
      }

      return await response.json();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong. Please try again later."
      );
    }
  }
);
const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: localStorage.getItem("orders")
      ? JSON.parse(localStorage.getItem("orders"))
      : [],
    orderLoading: false,
    error: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.orderLoading = true;
        state.error = false;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.error = false;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.orderLoading = false;
        state.error = true;
      })
      .addCase(getAllOrders.pending, (state) => {
        state.orderLoading = true;
        state.error = false;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.orderLoading = false;
        state.error = false;
        state.orders = [...action.payload.orders];
        localStorage.setItem("orders", JSON.stringify(action.payload.orders));
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.orderLoading = false;
        state.error = true;
      });
  },
});

export default orderSlice.reducer;
